import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { ProductService } from '../services/product.service';
import { EvendProductType } from "../models/evendProduct";
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-products-type',
    templateUrl: './products-type.component.html',
    styleUrls: ['./products-type.component.css']
})
export class ProductsTypeComponent implements OnInit {
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('successSwal') private successSwal: SwalComponent;

    @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
    @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
  
    evendProductTypes = [new EvendProductType(-1)];
    newEvendProductType = new EvendProductType(-1);
    editEvendProductType = new EvendProductType(-1);
    public errorMessage = '';
  
    typePage = 1;
    typePages = 1;
    selector: string = '.evend-products-type-list';

    constructor(
        private productService: ProductService,
        private spinner: NgxSpinnerService,
        private router: Router) {
    }

    ngOnInit() {
        this.getEvendProductTypes();
    }

    getEvendProductTypes() {
      this.productService.getEvendProductTypes(this.typePage).subscribe(res => {
        this.evendProductTypes = res.docs;
        this.typePages = res.pages;
      }, error => {
        console.log(error);
        if (error.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          this.router.navigate(['/login']);
        } else {
          this.errorSwal.title = error.status;
          this.errorSwal.text = error.error;
          this.errorSwal.show();
          console.log('Error:', error);
        }
      });
    }

    createEvendProductType() {
        if (!this.checkIsFieldsOkay(false))  { return ; }
        if (this.isExist(this.newEvendProductType.name, 0)) { return; }
        this.newEvendProductType.status = +this.newEvendProductType.status;
        this.productService.createEvendProductType(this.newEvendProductType).subscribe(response => {
          this.spinner.hide();
          this.successSwal.text = 'Ürün türü başarıyla oluşturuldu!';
          this.successSwal.show();
          this.closeCreateModal.nativeElement.click();
          this.getEvendProductTypes();
        }, error => {
          this.spinner.hide();
          if (this.errorSwal) {
              this.errorSwal.text = 'Ürün türü oluşturulurken hata oluştu!';
              this.errorSwal.show();
          }
        });
        this.clearEvendProductType();
    }

    updateEvendProductType() {
        if (!this.checkIsFieldsOkay(true)) {  return; }
        if (this.isExist(this.editEvendProductType.name, this.editEvendProductType._id)) { return; }
        this.spinner.show();
        this.productService.updateEvendProductType(this.editEvendProductType, this.editEvendProductType._id).subscribe(res => {
          this.successSwal.title = 'Başarılı!';
          this.successSwal.show();
          this.closeUpdateModal.nativeElement.click();
          this.getEvendProductTypes();
          this.clearEvendProductType();
          this.spinner.hide();
        }, error => {
          if (error.message === 'Error: Access Denied') {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            this.router.navigate(['/login']);
            this.spinner.hide();
          } else {
            this.errorSwal.title = error.status;
            this.errorSwal.text = error.error;
            this.errorSwal.show();
            this.spinner.hide();
          }
        });
    }

    deleteEvendProductType(id) {
        if (id === '' || id === undefined) {
            if (this.errorSwal) {                
                this.errorSwal.title = 'Ürün id alınamadı!';
                this.errorSwal.show();
            }
          return;
        }
        this.spinner.show();
        this.productService.deleteEvendProductType(id).subscribe(res => {
          this.successSwal.title = 'Başarılı!';
          this.successSwal.show();
          this.getEvendProductTypes();
          this.spinner.hide();
        }, error => {
          if (error.message === 'Error: Access Denied') {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            this.router.navigate(['/login']);
            this.spinner.hide();
          } else {
              if (this.errorSwal) {                  
                  this.errorSwal.title = error.status;
                  this.errorSwal.text = error.error;
                  this.errorSwal.show();
              }
            this.spinner.hide();
          }
        });
    }
    clearEvendProductType() {
        this.newEvendProductType = new EvendProductType(-1);
        this.editEvendProductType = new EvendProductType(-1);
        this.errorMessage = '';
    }

    checkIsFieldsOkay(isEdit: boolean): boolean {
        let isOkay = true;
        if (isEdit) {
            if (this.editEvendProductType.name === '' || this.editEvendProductType.name === undefined || this.editEvendProductType.status === -1) { isOkay = false; }
        } else {
            if (this.newEvendProductType.name === '' || this.newEvendProductType.name === undefined || this.newEvendProductType.status === -1) { isOkay = false; }
        }
        if (!isOkay) {
            if (this.errorSwal) {                
                this.errorSwal.text = 'Lütfen tüm alanları doldurunuz ve negatif değerler girmeyiniz!';
                this.errorSwal.show();
            }
          return false;
        } else {
          return true;
        }
    }

    isExist(name, id) {
      if (this.evendProductTypes) {        
        const result =  this.evendProductTypes.some(type =>  {
            if (type.name && type._id) {
                type.name.toLowerCase() === name.toLowerCase() && type._id !== id
            }
            return result;
        });
        if (result) {
          this.errorMessage = 'Bu isimli bir ürün türü mevcuttur!';
          this.spinner.hide();
        }
        return result;
      } else {
        return false;
      }
    }

    selected(Type) {
        this.clearEvendProductType();
        this.editEvendProductType = Object.assign({}, Type);
    }

    onScrollTypes() {
      if (this.typePage + 1 > this.typePages) { return; }
        $('#page-loader').fadeIn();
        this.typePage += 1;
        this.productService.getEvendProductTypes(this.typePage)
            .subscribe(response => {
                $('#page-loader').fadeOut();
                for (const item of response.docs) {
                    this.evendProductTypes.push(item);
                    this.evendProductTypes = [...this.evendProductTypes];
                }
                this.typePages = response.pages;
            }, error => {
                $('#page-loader').fadeOut();
                this.errorSwal.title = 'Automat devamı yüklenemedi!';
                this.errorSwal.show();      
            });
  }

}




// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/products-type/products-type.component.ts